import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { usePrefs } from 'wsm-common-data';
import VehicleCardData from './VehicleCardData';
import HighlightedAttributeContainer from './HighlightedAttributeContainer';
import WebIntegrationPlaceholder from '../../WebIntegrationPlaceholder';

const Details = ({
	vehicle,
	incentives,
	accounts,
	isTabbedLayout,
	isGridLayout
}) => {
	const { accountId } = useSelector((state) => state.widgetInfo);

	const { showPricingSummary } = usePrefs();

	const gridPlaceholderLocation =
		showPricingSummary === 'true' && (isGridLayout || isTabbedLayout) ? (
			<WebIntegrationPlaceholder location="vehicle-payments-primary" />
		) : (
			''
		);

	return (
		<>
			{gridPlaceholderLocation}
			<HighlightedAttributeContainer
				isGridLayout={isGridLayout}
				accountInfo={{
					...accounts[vehicle.accountId],
					id: vehicle.accountId,
					fuelType: vehicle.fuelType
				}}
				vehicle={vehicle}
			/>
			<VehicleCardData
				accountId={accountId}
				accountInfo={{ ...accounts[vehicle.accountId] }}
				incentives={incentives}
				isGridLayout={isGridLayout}
				isTabbedLayout={isTabbedLayout}
				vehicle={vehicle}
			/>
		</>
	);
};

Details.propTypes = {
	vehicle: PropTypes.shape({
		title: PropTypes.arrayOf(PropTypes.string),
		uuid: PropTypes.string,
		link: PropTypes.string,
		accountId: PropTypes.string,
		condition: PropTypes.string,
		callout: PropTypes.arrayOf(PropTypes.shape({})),
		packages: PropTypes.arrayOf(PropTypes.string),
		incentiveIds: PropTypes.arrayOf(PropTypes.string),
		bestIncentiveIds: PropTypes.arrayOf(PropTypes.string),
		inventoryButtons: PropTypes.arrayOf(PropTypes.shape({})),
		images: PropTypes.arrayOf(PropTypes.shape({})),
		attributes: PropTypes.arrayOf(PropTypes.shape({})),
		highlightedAttributes: PropTypes.arrayOf(PropTypes.shape({})),
		pricing: PropTypes.shape({}),
		year: PropTypes.number,
		model: PropTypes.string,
		trim: PropTypes.string,
		make: PropTypes.string,
		vin: PropTypes.string,
		fuelType: PropTypes.string
	}).isRequired,
	incentives: PropTypes.shape({}),
	accounts: PropTypes.shape({}),
	isTabbedLayout: PropTypes.bool.isRequired,
	isGridLayout: PropTypes.bool
};

Details.defaultProps = {
	incentives: {},
	accounts: {}
};

export default Details;
